import React from 'react';
import styles from './LoaderIcon.module.scss';

const LoaderIcon: React.FC = () => {
	return <i className={styles.loader}></i>;
};

export default LoaderIcon;
